import firebase from 'firebase';
import store from './store';
import * as UserActions from "./actions/UserActions";
require("firebase/firestore");

let IS_AUTHENTICATED = undefined;
let TEAM_ID = null;

let config = {
    apiKey: "AIzaSyCU4bSPuQEfb-KW_GAMZtd3S1BpATOBKsc",
    authDomain: "t-rex-b476a.firebaseapp.com",
    databaseURL: "https://t-rex-b476a.firebaseio.com",
    projectId: "t-rex-b476a",
    storageBucket: "t-rex-b476a.appspot.com",
    messagingSenderId: "847450240387"
};
firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(async authUser => {
    if (authUser) {

        const user = await firestore
            .doc('users/' + authUser.uid)
            .get();

        if(user.exists) {
            TEAM_ID = user.data().team.id;
            IS_AUTHENTICATED = true;
            store.dispatch(UserActions.setActiveUser(authUser.uid))
        }
    } else {
        IS_AUTHENTICATED = false;
        store.dispatch(UserActions.setActiveUser(null))
    }
});

export const firestore = firebase.firestore();

export default firebase;

export function isAuthenticated(){
    return IS_AUTHENTICATED;
}
export function signOut(){
    firebase.auth().signOut();
}
export function getBasePath(){
    return TEAM_ID ? "teams/" + TEAM_ID : null;
}
export function getTeamId() {
    return TEAM_ID;
}


// WEBPACK FOOTER //
// ./src/firebase.js